import React, { Component } from "react";
import {
  Modal,
  Input,
  Button,
  Radio,
  message,
  Spin,
  Row,
  Col,
  DatePicker,
  Select,
  Popover,
} from "antd";
import moment from "moment";
import instance from "../../store/actions/instance";

import {
  LoadingOutlined,
  PlusOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { fetchRFM } from "../../store/actions/reports";
import CustomModal from "./CustomModal";

const { TextArea } = Input;
const { RangePicker } = DatePicker;
const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

function RadioButt({ selected, title, onClick, disabled, exp, language }) {
  return (
    <div
      style={{
        width: "100%",
        height: "50px",
        borderColor: "#0099cc",
        background: selected ? "#0099cc47" : "transparent",
        borderRadius: 3,
        border: "1px solid #0099cc",
        padding: 12,
        templates: [],
      }}
      onClick={() => {
        if (!disabled) onClick();
      }}
    >
      <Radio checked={selected} disabled={disabled}>
        {title}{" "}
      </Radio>
      {!!exp && (
        <Popover
          placement="bottom"
          content={
            <div style={{ maxWidth: 350 }}>
              <p>{exp}</p>
            </div>
          }
          title={title.split(" (")[0]}
        >
          <InfoCircleOutlined
            style={{
              fontSize: 14,
              color: "#0099cc",
              position: "relative",
              top: 4,
              float: language === "arabic" ? "left" : "right",

              margin:
                language == "arabic" ? "0px 5px 0px 10px" : "0px 10px 0px 5px",
            }}
          />
        </Popover>
      )}
    </div>
  );
}

class NewWhatsAppCampaignModal extends Component {
  state = {
    name: "",
    purpose: "retain",
    template: null,
    templates: [],
    saveLoading: false,
    segment: null,
    rfmLoading: false,
    start: moment().add(-90, "days").format("YYYY-MM-DD"),
    end: moment().format("YYYY-MM-DD"),
    customersType: "customers",
    countriesCodes: [],

    customModalVisible: false,
    selectedCustomers: [],
    selectedCustomersNumbers: [],
  };

  componentDidMount() {
    this.findDefaultCountry();
    this.fetchRFM();
    this.fetchTemplates();
  }

  findDefaultCountry = () => {
    const { settings } = this.props;
    const countriesArray = [
      { Kuwait: "+965" },
      { Oman: "+968" },
      { Bahrain: "+973" },
      { "Saudi Arabia": "+966" },
      { "United Arab Emirates": "+971" },
      { Qatar: "+974" },
    ];
    let default_country = [];
    const filtered = countriesArray.find(
      (c) =>
        Object.keys(c)[0].toLowerCase() ===
        settings.all_countries?.[0]?.name?.toLowerCase()
    );
    if (filtered) {
      default_country = [Object.values(filtered)[0]];
    }
    this.setState({ countriesCodes: default_country });
  };

  fetchRFM = () => {
    const { start, end, customersType, countriesCodes } = this.state;
    const { t } = this.props;
    this.setState({ rfmLoading: true });
    this.props
      .fetchRFM(
        start,
        end,
        t,
        customersType,
        "whatsappCampign",
        "custom",
        countriesCodes
      )
      .finally(() => this.setState({ rfmLoading: false }));
  };

  fetchTemplates = async () => {
    try {
      const res = await instance.get("/fetch_whatsapp_templates/");
      if (res.data.success && Array.isArray(res.data.fetched_templates)) {
        const templates = res.data.fetched_templates
          .filter((template) => template.status?.toLowerCase() === "approved")
          .map((template) => ({
            id: template.id,
            name: template.name,
            body: template.body_text || template.body || "",
            // category: template.category,
            language: template.language,
            status: template.status?.toLowerCase(),
          }));
        this.setState({ templates });
      }
    } catch (error) {
      console.error("Template Fetch Error", error);
    }
  };

  handleCreate = async () => {
    const {
      name,
      purpose,
      template,
      segment,
      start,
      end,
      selectedCustomersNumbers,
    } = this.state;
    const { t } = this.props;

    if (!name.trim() || !template || !segment) {
      message.warning(t("Please provide all required fields."));
      return;
    }

    this.setState({ saveLoading: true });
    try {
      const res = await instance.post("/create_whatsapp_campaign/", {
        name,
        purpose,
        template_id: template.id,
        segment,
        start,
        end,
        selectedCustomersNumbers,
      });
      if (res.data.success) {
        message.success(t("Campaign created successfully!"));
        this.props.onClose(true);
      } else {
        message.error(res.data.message || t("SomethingWentWrong"));
      }
    } catch (e) {
      console.error("Create Error", e);
      message.error(t("SomethingWentWrong"));
    }
    this.setState({ saveLoading: false });
  };

  render() {
    const { visible, onClose, t, config, settings, rfmData = {} } = this.props;
    const {
      name,
      purpose,
      template,
      templates,
      saveLoading,
      segment,
      start,
      end,
      rfmLoading,
      countriesCodes,
      customersType,
      customModalVisible,
      selectedCustomers,
      selectedCustomersNumbers,
    } = this.state;

    return (
      <Modal
        maskClosable={false}
        destroyOnClose
        visible={visible}
        onCancel={onClose}
        title={t("New WhatsApp Campaign")}
        okText={t("Create Campaign")}
        onOk={this.handleCreate}
        okButtonProps={{
          loading: saveLoading,
          disabled: !name || !template || !segment,
        }}
        cancelText={t("Cancel")}
        width={900}
      >
        {customModalVisible && (
          <CustomModal
            visible={customModalVisible}
            selectedCustomers={selectedCustomers}
            onClose={(
              shouldUpdate,
              selectedRowKeys,
              selectedRowKeysNumbers
            ) => {
              this.setState({ customModalVisible: false });
              if (shouldUpdate) {
                this.setState({
                  selectedCustomers: selectedRowKeys,
                  selectedCustomersNumbers: selectedRowKeysNumbers,
                });
              }
            }}
          />
        )}
        <div>
          <p className="bold mb-2">{t("Campaign name")}</p>
          <Input
            value={name}
            onChange={(e) => this.setState({ name: e.target.value })}
            placeholder={t("Ex: Weekend Offer")}
          />

          <p className="mt-4 bold">{t("Campaign purpose")}</p>
          <Radio.Group
            value={purpose}
            buttonStyle="solid"
            onChange={(e) => this.setState({ purpose: e.target.value })}
          >
            <Radio.Button value="retain">
              {t("Increase retention rate")}
            </Radio.Button>
            <Radio.Button value="increase basket">
              {t("Increase average order value")}
            </Radio.Button>
            <Radio.Button value="re-engage">
              {t("Increase engagement")}
            </Radio.Button>
            <Radio.Button value="encourage">{t("Increase sales")}</Radio.Button>
          </Radio.Group>

          <p className="mt-4 bold">{t("Date range")}</p>
          <RangePicker
            value={[moment(start, "YYYY-MM-DD"), moment(end, "YYYY-MM-DD")]}
            onChange={(dates, dateStrings) => {
              this.setState(
                { start: dateStrings[0], end: dateStrings[1] },
                this.fetchRFM
              );
            }}
            allowClear={false}
            disabledDate={(current) => current > moment()}
          />

          {settings.enable_businesses && (
            <Select
              className="mt-3"
              defaultValue={customersType}
              onChange={(val) =>
                this.setState({ customersType: val }, this.fetchRFM)
              }
            >
              <Option value="customers">{t("Customers")}</Option>
              <Option value="business">{t("Business")}</Option>
            </Select>
          )}

          {settings.is_gcc && (
            <Select
              className="mt-3 ml-2"
              mode="multiple"
              value={countriesCodes}
              onChange={(value) =>
                this.setState({ countriesCodes: value }, this.fetchRFM)
              }
              placeholder={t("Filter by country")}
            >
              <Option value="+965">{t("Kuwait")}</Option>
              <Option value="+973">{t("Bahrain")}</Option>
              <Option value="+974">{t("Qatar")}</Option>
              <Option value="+966">{t("Saudi Arabia")}</Option>
              <Option value="+968">{t("Oman")}</Option>
              <Option value="+971">{t("United Arab Emirates")}</Option>
            </Select>
          )}

          <p className="mt-4 bold">{t("Targeted segment")}</p>
          {rfmLoading ? (
            <div className="my-4 text-center">
              <Spin indicator={antIcon} />
            </div>
          ) : (
            <Row gutter={[10, 10]} style={{ marginTop: 10 }}>
              {Object.keys(rfmData)
                .filter((key) => key !== "all_store_customers")
                .map((key) => (
                  <Col span={8} key={key}>
                    <RadioButt
                      selected={segment === key}
                      title={`${t(
                        key.charAt(0).toUpperCase() + key.slice(1)
                      )} (${rfmData[key]})`}
                      onClick={() => this.setState({ segment: key })}
                      disabled={rfmData[key] === 0}
                      language={config.language}
                      exp={""}
                    />
                  </Col>
                ))}
              <Col span={8}>
                <RadioButt
                  selected={segment === "custom"}
                  title={`${t("Custom")}`}
                  onClick={() =>
                    this.setState({
                      segment: "custom",
                      customModalVisible: true,
                    })
                  }
                  language={config.language}
                />
              </Col>
            </Row>
          )}

          <p className="mt-4 bold">{t("Choose WhatsApp Template")}</p>
          <Select
            placeholder={t("Select a WhatsApp Template")}
            value={template?.id}
            onChange={(id) => {
              const selected = templates.find((tpl) => tpl.id === id);
              this.setState({ template: selected });
            }}
            style={{ width: "100%" }}
          >
            {templates.map((tpl) => (
              <Option key={tpl.id} value={tpl.id}>
                {tpl.name} ({tpl.language})
              </Option>
            ))}
          </Select>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    user: state.auth.username,
    rfmData: state.reports.rfmData?.totals,
    customer_list: state.reports.rfmData?.customer_list,
    settings: state.auth.settings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchRFM: (start, end, t, customersType, from, period, countriesCodes) =>
      dispatch(
        fetchRFM(start, end, t, customersType, from, period, countriesCodes)
      ),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(NewWhatsAppCampaignModal));
